import { ApiError } from "components";
import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import {
  CreateSpecialOfferInput,
  SpecialOfferInputError,
} from "../state/actionType";
import { connect } from "react-redux";
import { createSpecialOffer, resetSpecialOffer, } from "../state/action";
import SpecialOfferForm from "./form/SpecialOfferForm";
import { FormDataValidation } from "./components/FormDataValidation";
import { SpecialOfferStatus } from "props/enum";

interface OwnProps {
  onClose: () => void;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & OwnProps;
const HandleCreateSpecialOffer: React.FC<Props> = ({
  onClose,
  onResetSpecialOffer,
  onCreateSpecialOffer,
}) => {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [apiError, setApiError] = useState(null);
  const [formData, setFormData] = useState<CreateSpecialOfferInput>({
    status: SpecialOfferStatus.InActive,
    title: '',
    description: '',
    start_date: '',
    end_date: '',
    membership_duration_id: '',
    number_of_days: '',
  });
  
  const [formError, setFormError] = useState<SpecialOfferInputError>({});
  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === "featured_order" ? Number(value) : value,
    }));
    setFormError((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };
  const handleSave = async (e: React.FormEvent | React.MouseEvent) => {
    e.preventDefault();
    const validationErrors = FormDataValidation(formData);
    if (Object.keys(validationErrors).length > 0) {
      setFormError(validationErrors);
      return;
    }
     setLoading(true);
    const input: CreateSpecialOfferInput = {
      status: SpecialOfferStatus.InActive,
      title: formData.title,
      description: formData.description,
      start_date: formData.start_date,
      end_date: formData.end_date,
      membership_duration_id: formData.membership_duration_id,
      number_of_days: formData.number_of_days
    };
    if (
      formData.title.trim() !== "" &&
      formData.description.trim() !== "" &&
      formData.start_date.trim() !==  "" &&
      formData.end_date.trim() !== "" &&
      String(formData.number_of_days).trim() !== "" &&
      String(formData.membership_duration_id).trim() !== ""
    ) {
      await onCreateSpecialOffer(input);
      setSubmitted(true);
    }
     setLoading(false);
  };
  return (
    <>
        <>
          <SpecialOfferForm
            header={"Create Featured Ads"}
            formData={formData}
            formError={formError}
            handleChange={handleChange}
            handleSubmit={handleSave}
            loading={loading}
            onClose={onClose}
          />
          {apiError && <ApiError>{apiError}</ApiError>}
        </>
    </>
  );
};
const mapDispatchToProps = (dispatch: any) => ({
  onCreateSpecialOffer: (input: CreateSpecialOfferInput) =>
    dispatch(createSpecialOffer(input)),
  onResetSpecialOffer: () => dispatch(resetSpecialOffer()),
});
export default connect(null, mapDispatchToProps)(HandleCreateSpecialOffer);
